
$(function () {
    window.initCountdown();
});


/**
 * Slider container element
 */
window.initCountdown = function ($object = null){


    if (null === $object) {
        $object = $('.countdown')
    } else if (!$($object).is('countdown')) {
        $object = $($object).find('.countdown')
    }


    $object.each(function () {

        const $element = $(this);

        const $countdownElement = $(this).find('.countdown-element');
        let destination = 0;
        const now = new Date().getTime();

        const dataDuration = $countdownElement.data('countdown-duration');
        const dataDate = $countdownElement.data('countdown-date');

        if (dataDuration) {
            destination = dataDuration * 1000 + now;
        } else if (dataDate) {
            destination = new Date(dataDate);
        }

        if (!destination || destination <= 0) {
            $element.remove();
            return;
        }

        const $daysContainer = $countdownElement.find('.days-container');
        const $daysText = $countdownElement.find('.days-text');
        const $daysCount = $countdownElement.find('.days-count');
        const $hoursText = $countdownElement.find('.hours-text');
        const $hoursCount = $countdownElement.find('.hours-count');
        const $minutesText = $countdownElement.find('.minutes-text');
        const $minutesCount = $countdownElement.find('.minutes-count');
        const $secondsText = $countdownElement.find('.seconds-text');
        const $secondsCount = $countdownElement.find('.seconds-count');

        const hasSeconds = $secondsCount.length > 0;

        let interval = setInterval(function () {
            calculateCountdown();
        }, 1000);

        // Init
        calculateCountdown();

        function calculateCountdown () {
            // Get todays date and time
            const now = new Date().getTime();

            // Find the duration between now and the count down date
            let duration = destination - now;

            if (!hasSeconds) {
                // Add one minute if seconds are not displayed
                duration += 60000;
            }

            // If the count down is finished, clear interval
            if (duration <= 0) {
                if (interval) {
                    clearInterval(interval);
                    $element.slideUp();
                }
                // setTimeout(function (){
                //     location.reload();
                // }, 1500);
            }

            // Time calculations for days, hours, minutes and seconds
            const days = Math.max(0, Math.floor(duration / (1000 * 60 * 60 * 24)));
            const hours = Math.max(0, Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
            let minutes = Math.max(0, Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60)));
            const seconds = Math.max(0, Math.floor((duration % (1000 * 60)) / 1000));

            if (hasSeconds) {
                // Hide days if == 0
                if (!days) {
                    $daysContainer.hide();
                }
            }

            const daysText = 'Tag' + (1 !== days ? 'e' : '');
            const hoursText = 'Stunde' + (1 !== hours ? 'n' : '');
            const minutesText = 'Minute' + (1 !== minutes ? 'n' : '');
            const secondsText = 'Sekunde' + (1 !== seconds ? 'n' : '');

            $daysText.text(daysText);
            $hoursText.text(hoursText);
            $minutesText.text(minutesText);
            $secondsText.text(secondsText);

            $daysCount.text(addLeadingZero(days));
            $hoursCount.text(addLeadingZero(hours));
            $minutesCount.text(addLeadingZero(minutes));
            $secondsCount.text(addLeadingZero(seconds));
        }

        function addLeadingZero (time) {
            if (time < 10) {
                time = '0' + time.toString();
            }

            return time;
        }

    });

};
